import { useHomeModel } from '@/components/home/home.model'
import { HomeView } from '@/components/home/home.view'

export function HomeViewModel() {
  const model = useHomeModel()
  return <HomeView {...model} />
}
